import Vue from 'vue'
import Router from 'vue-router'
import {getToken} from '@/util'
import CustomLayout from '@/views/layout/CustomRouter'
import store from './store'
import { Toast } from 'vant'


Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/', redirect: '/home'
        },
        {
            path: '/login',
            name: 'login',
            meta: {
                title: '登录',
            },
            component: () => import('./views/login/Index.vue')
        },
        {
            path: '/home',
            name: 'home',
            meta: {
                title: '首页',
                hideBack: true,
                rightIcon: 'search',
                rightText: '筛选',
            },
            component: () => import('./views/home/Index.vue')
        },
        {
            path: '/order',
            name: 'order',
            meta: {
                title: '数据',
                hideBack: true,
                rightIcon: 'search',
                rightText: '筛选',
            },
            component: () => import('./views/order/Index.vue')
        },
        {
            path: '/order-count',
            name: 'order-count',
            meta: {
                title: '统计',
                hideBack: true,
                rightIcon: 'search',
                rightText: '筛选',
            },
            component: () => import('./views/order/Count.vue')
        },
        {
            path: '/my',
            name: '_my',
            component: CustomLayout,
            children: [
                {
                    path: 'index',
                    name: 'my-index',
                    meta: {
                        title: '我的',
                        hideBack: true,
                    },
                    component: () => import('./views/my/Index.vue'),
                },
                {
                    path: 'pass-edit',
                    name: 'my-pass-edit',
                    meta: {
                        title: '修改密码',
                    },
                    component: () => import('./views/my/EditPass.vue'),
                },
                {
                    path: 'change-mobile',
                    name: 'my-change-mobile',
                    meta: {
                        title: '更换手机',
                    },
                    component: () => import('./views/my/ChangeMobile.vue'),
                }
            ]
        },
    ]
})

router.beforeEach(async (to, from, next) => {
    // let menuIndex = _.indexOf(MENU_ARRAY, to.name)
    // if (menuIndex != -1) {
    //     store.commit('setTabActive', { data: menuIndex })
    // }
    let token = getToken();
    let loginName = 'login'
    let homeName = 'home'
    if (!token && to.name != loginName) {
        next({name: loginName})
    } else if (token && to.name == loginName) {
        next({name: homeName})
    } else {
        if (token && _.isEmpty(store.state.userInfo)) {
            try {
                await store.dispatch('getUserInfo')
                next()
            }catch (e) {
                Toast(e.toString())
            }
        } else {
            next()
        }
    }
})

export default router
